module.exports = __webpack_public_path__ + "img/0dd7f76eb2fd3a9d4a194306e7e0daa9.png";